import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/AuthService';

export const ACCOUNT_PATH = '/admin/account';

/** Куда отправляем сотрудника, которому нужно сменить выданный администратором пароль. */
export function passwordChangeUrl(router: Router): UrlTree {
  return router.createUrlTree([ACCOUNT_PATH], { queryParams: { tab: 'password', required: 1 } });
}

export function isAccountUrl(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return path === ACCOUNT_PATH || path.startsWith(`${ACCOUNT_PATH}/`);
}

/**
 * Пока у сотрудника must_change_password, все разделы /admin закрыты: бэк всё равно ответит
 * 403 password_change_required, поэтому сразу ведём на «Мой профиль» → «Пароль».
 */
export const passwordChangeGuard: CanActivateChildFn = (_route, state): boolean | UrlTree => {
  const auth = inject(AuthService);
  if (!auth.mustChangePassword() || isAccountUrl(state.url)) {
    return true;
  }
  return passwordChangeUrl(inject(Router));
};
